import { Fade, FadeProps } from 'react-awesome-reveal'


const FadeWrapper = ({ children, ...props }: FadeProps) => {
  return <Fade {...props} triggerOnce>{children}</Fade>
}

export default FadeWrapper
